import { useEffect, useState } from "react";
import { getConfig } from "../api/endpoints";

// Экран-подсказка, когда приложение открыто вне Telegram (нет initData).
export default function OpenInTelegram() {
  const [bot, setBot] = useState<string | null>(null);
  useEffect(() => { getConfig().then((c) => setBot(c.bot_username)).catch(() => {}); }, []);

  const link = bot ? `https://t.me/${bot}` : undefined;

  return (
    <div className="splash">
      <div className="splash__brand">Storosilov<br />Vintage</div>
      <p style={{ color: "var(--hint)", fontSize: 14, maxWidth: 320, lineHeight: 1.5 }}>
        Магазин открывается внутри Telegram. Откройте его через бота — там подтянутся ваш профиль и заказы.
      </p>
      {link && (
        <a href={link} className="btn" style={{ width: "auto", padding: "12px 24px", textDecoration: "none" }}>
          Открыть в Telegram
        </a>
      )}
    </div>
  );
}
